var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnduDraft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draft-cancel"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.04 74.83 71.31 64.11 64.11 71.31 74.83 82.04 64.03 92.85 71.18 100 81.99 89.19 92.71 99.92 99.92 92.71 89.19 81.99 100 71.18 92.85 64.03 82.04 74.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.65,92.95l10.81-10.81-10.73-10.73,15.69-15.69,8.58,8.58V30L50,0H10C4.5,0,.05,4.5.05,10l-.05,80c0,5.5,4.45,10,9.95,10h52.74l-7.05-7.05ZM45,7.5l27.5,27.5h-27.5V7.5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnduDraft);
export default __webpack_public_path__ + "static/media/unduDraft.4ca6c644bffc15058f57333050cfa99f.svg";
export { ForwardRef as ReactComponent };